import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';

ng.module('e360').factory('dialogs', dialogsFactory);

export type DialogButton = 'ok' | 'cancel' | 'delete' | 'yes' | 'no';

dialogsFactory.$inject = ['$uibModal'];
export function dialogsFactory($modal: uib.IModalService) {
   return {
      alert: (message) => showDialog(message, ['ok']),
      confirm: (message) => showDialog(message, ['ok', 'cancel']),
      delete: (message) => showDialog(message, ['delete', 'cancel']),
      yesno: (message) => showDialogYesNo(message, ['yes', 'no'])
   };

   function showDialog(message: string, buttons: DialogButton[]) {
      return $modal.open({
         component: 'confirmationDialog',
         resolve: {
            buttons: () => buttons,
            message: () => message
         }
      }).result;
   }

   function showDialogYesNo(message: string, buttons: DialogButton[]) {
      var options = {
         component: 'yesNoDialog',
         resolve: {
            buttons: () => buttons,
            message: () => message
         },
         backdrop: 'static',
         keyboard: false
      };
      return $modal.open(options).result;
   }
}
